import React from 'react';
import { AxiosError } from 'axios';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { User } from '../../../services/types/User';
import { SpecialRole } from '../../../types/role';
/* eslint-disable @typescript-eslint/no-unused-vars */

export interface ServiceOptions<T> {
  loader?: (value: boolean) => void;
  callback?: (data: T) => void;
  onError?: (error: AxiosError | Error) => boolean | void;
}

interface MainContext {
  user: User;
  ezShareSiteUrl: string;
  countries: string[];
  mainLoading: boolean;
  notify: (title: string, message: string, color: string, icon?: IconProp) => void;
  notifyError: (error: AxiosError | Error) => void;
  service: <T>(func: () => Promise<T>, options?: ServiceOptions<T>) => Promise<void>;
  updateAsSpecialUserMode: (mode: SpecialRole | null) => void;
  inSuperUserMode: () => boolean;
  inGuidanceServiceMode: () => boolean;
}

const MainContext = React.createContext<MainContext>({
  user: {} as User,
  ezShareSiteUrl: '',
  countries: [],
  mainLoading: true,
  notify: (title, message, color) => {},
  notifyError: (error: AxiosError | Error | unknown) => {},
  service: <T>(func: () => Promise<T>, options?: ServiceOptions<T>) => Promise.resolve(undefined),
  updateAsSpecialUserMode: (mode: SpecialRole | null) => {},
  inSuperUserMode: () => {
    const currentValue = sessionStorage.getItem('esg_as_super_user_mode') || 'false';

    return JSON.parse(currentValue) as boolean;
  },
  inGuidanceServiceMode: () => {
    const currentValue = sessionStorage.getItem('esg_as_guidance_service_mode') || 'false';

    return JSON.parse(currentValue) as boolean;
  },
});

export default MainContext;
